import {get, set} from "./_cookie";

const cookiebar = document.querySelector('.js-cookiebar');

if(cookiebar && !get('cookies')) {
    const actions = [...cookiebar.querySelectorAll('.js-cookiebar-action')];

    const actionClickHandler = (e) => {
        const action = e.currentTarget.dataset.action;

        if(action === 'preferences') {
            cookiebar.setAttribute('data-preferences', '');
        } else {
            set('cookies', +action, 14);
            cookiebar.removeAttribute('data-open');
        }
    }

    cookiebar.setAttribute('data-open', '');
    actions.map((action) => action.addEventListener('click', actionClickHandler));
}
